import { render, staticRenderFns } from "./addReserveCatalog.vue?vue&type=template&id=db9cf4c2"
import script from "./addReserveCatalog.vue?vue&type=script&lang=js"
export * from "./addReserveCatalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports